import Swiper from "swiper";
import { FreeMode, Navigation, Pagination } from "swiper/modules";

const selectors = {
  block: "[data-pc]",
  breadcrumbs: "[data-pc-bc]",
  description: "[data-pc-description]",
};

const setScheme = (container, pagination, breadcrumbs, descriptions, activeIndex, previousIndex, slides) => {
  const prevScheme = slides[previousIndex]?.dataset.pcScheme.split(" ") || [];
  const activeScheme = slides[activeIndex]?.dataset.pcScheme.split(" ");

  container.classList.remove(...prevScheme);
  container.classList.add(...activeScheme);

  pagination.classList.remove(prevScheme[0]);
  pagination.classList.add(activeScheme[0]);

  breadcrumbs.classList.remove(prevScheme[0]);
  breadcrumbs.classList.add(activeScheme[0]);

  descriptions.forEach((description, index) =>
    description.classList[index === activeIndex ? "add" : "remove"]("active")
  );
};

const initSwiper = (container) => {
  const pagination = container.querySelector("[data-swiper-pagination]");
  const breadcrumbs = container.querySelector(selectors.breadcrumbs);
  const descriptions = container.querySelectorAll(selectors.description);

  new Swiper(container.querySelector(".swiper"), {
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 24,
    centeredSlides: true,
    speed: 750,
    slideToClickedSlide: true,

    breakpoints: {
      1024: {
        slidesPerView: "auto",
      },
    },

    navigation: {
      prevEl: container.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: container.querySelector('[data-swiper-navigation="next"]'),
    },

    pagination: {
      el: pagination,
    },

    on: {
      realIndexChange: ({ activeIndex, previousIndex, slides }) =>
        setScheme(container, pagination, breadcrumbs, descriptions, activeIndex, previousIndex, slides),
      init: ({ activeIndex, previousIndex, slides }) =>
        setScheme(container, pagination, breadcrumbs, descriptions, activeIndex, previousIndex, slides),
    },
  });
};

const initBlock = (block) => {
  Swiper.use([Navigation, Pagination, FreeMode]);

  initSwiper(block);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
